var map = {
	"./Index.vue": [
		"d504",
		"chunk-d8763076",
		"chunk-1280e9a0",
		"chunk-6e55cf44",
		"chunk-4422cfbc",
		"chunk-22ed6a41"
	],
	"./admin/Dashboard.vue": [
		"0a6e",
		"chunk-d8763076",
		"chunk-6fc01cc4"
	],
	"./admin/ManageLecturer.vue": [
		"da14",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-cce6d4f0",
		"chunk-3169e46b",
		"chunk-90fc8364",
		"chunk-db397138",
		"chunk-7fdbb28e"
	],
	"./admin/ManageMajor.vue": [
		"3d72",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-fa73787e",
		"chunk-7ae2e164",
		"chunk-44fb04db",
		"chunk-2d184844",
		"chunk-2d19e48e"
	],
	"./admin/ManagePermission.vue": [
		"0523",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-73221c10",
		"chunk-7ae2e164",
		"chunk-44fb04db",
		"chunk-2d184844",
		"chunk-326fee48"
	],
	"./admin/ManageRole.vue": [
		"7519",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-11923a51",
		"chunk-a97b1978",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-515d8a3e"
	],
	"./admin/ManageStudent.vue": [
		"fc86",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7ae744eb",
		"chunk-5f9eafb1",
		"chunk-1ecf5a08",
		"chunk-45e48838",
		"chunk-2a4a6160"
	],
	"./admin/ManageUser.vue": [
		"f244",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-6568c3d4",
		"chunk-516b2f77",
		"chunk-74aefea6",
		"chunk-2d184844",
		"chunk-045924ea"
	],
	"./auth/Error404.vue": [
		"dea8",
		"chunk-1280e9a0",
		"chunk-4422cfbc",
		"chunk-251c9320"
	],
	"./auth/Index.vue": [
		"81cc",
		"chunk-2d0dda0f"
	],
	"./auth/RoleDashboard.vue": [
		"66f6",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-6e55cf44",
		"chunk-73a19a7e"
	],
	"./auth/SignIn.vue": [
		"ab23",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-2d22cfe3",
		"chunk-d990ede6",
		"chunk-fdd6c502",
		"chunk-1aeee832"
	],
	"./lecturer/Dashboard.vue": [
		"da39",
		"chunk-d8763076",
		"chunk-cb99aab2"
	],
	"./lecturer/Score.vue": [
		"a705",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-2d0b3a27",
		"chunk-4cb44237",
		"chunk-489c0498",
		"chunk-2d208d71"
	],
	"./lecturer/Session.vue": [
		"3165",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-971ab148"
	],
	"./major-admin/AnnualGen.vue": [
		"a891",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-325d52b2"
	],
	"./major-admin/AnnualScore.vue": [
		"55f9",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-f61bbb90"
	],
	"./major-admin/Dashboard.vue": [
		"e2b0",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-90822958"
	],
	"./major-admin/MajorAdminAnnualScore.vue": [
		"e056",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7ef9d28e",
		"chunk-a97b1978",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-6e454152"
	],
	"./major-admin/MajorAdminManageLecturer.vue": [
		"0769",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-2d0b3a27",
		"chunk-6499a187",
		"chunk-4c3e8416",
		"chunk-bfc84be6",
		"chunk-db397138",
		"chunk-cd74ef28"
	],
	"./major-admin/MajorAdminManageStudent.vue": [
		"858f",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-2d0b3a27",
		"chunk-d6f7cff8",
		"chunk-b5b9c604",
		"chunk-5aed021f",
		"chunk-45e48838",
		"chunk-6f570d42"
	],
	"./major-admin/MajorAdminTranscript.vue": [
		"df67",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-22a1dac9"
	],
	"./major-admin/ManageAcademicYear.vue": [
		"263a",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-a17e34b6",
		"chunk-36897888",
		"chunk-44fb04db",
		"chunk-1f6cf470",
		"chunk-9df4401e"
	],
	"./major-admin/ManageMajorGen.vue": [
		"61d4",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-2fa97426",
		"chunk-4ecac509",
		"chunk-ea521510"
	],
	"./major-admin/ManageScUser.vue": [
		"ec5b",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-367bb070",
		"chunk-8157dcc6",
		"chunk-74aefea6",
		"chunk-1f6cf470",
		"chunk-7db056ca"
	],
	"./major-admin/ManageScore.vue": [
		"a277",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-56073174"
	],
	"./major-admin/ManageSession.vue": [
		"3869",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-78501ac3",
		"chunk-4a872bd6",
		"chunk-1ecf5a08",
		"chunk-45e48838",
		"chunk-1f11a24b"
	],
	"./major-admin/ManageSessionScore.vue": [
		"ed7d",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7ef9d28e",
		"chunk-a97b1978",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-e7320b2e"
	],
	"./major-admin/ManageSubject.vue": [
		"2168",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-324e473e",
		"chunk-77f2c24d",
		"chunk-74aefea6",
		"chunk-2d184844",
		"chunk-4173d0de"
	],
	"./student/Dashboard.vue": [
		"a7ba",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-9f367018"
	],
	"./student/ScoreStudent.vue": [
		"8aeb",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7b1ba00f",
		"chunk-cb5c6ae8",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-05f76f0e"
	],
	"./student/SessionScoreStudent.vue": [
		"8d1c",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-3500a635",
		"chunk-d3750fee",
		"chunk-3005afd2",
		"chunk-f3c0fa3a",
		"chunk-65e4d47a",
		"chunk-cfecce60"
	],
	"./student/SessionStudent.vue": [
		"e7ac",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-3f35f420",
		"chunk-527ae954",
		"chunk-3005afd2",
		"chunk-250afd54",
		"chunk-3e8ad0ca"
	],
	"./student/StudentAnnual.vue": [
		"7cf7",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-5e2f6b75"
	],
	"./student/StudentAnnualScore.vue": [
		"5186",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7ef9d28e",
		"chunk-a97b1978",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-5678da31"
	],
	"./student/StudentTranscript.vue": [
		"ba2f",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-0c1d966a"
	],
	"./student/SubjectStudent.vue": [
		"9189",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-1278a955"
	],
	"./top-manager/TopManagerAnnual.vue": [
		"c699",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-d30fe0f8"
	],
	"./top-manager/TopManagerAnnualScore.vue": [
		"0d3c",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7ef9d28e",
		"chunk-a97b1978",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-63069ad2"
	],
	"./top-manager/TopManagerDashboard.vue": [
		"7300",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-3673cbb1"
	],
	"./top-manager/TopManagerGen.vue": [
		"d78d",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-0020c58b"
	],
	"./top-manager/TopManagerTranscript.vue": [
		"bf95",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-19ba677f"
	],
	"./tsc/Dashboard.vue": [
		"28c3",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-31df5678"
	],
	"./tsc/GenerateAnnual.vue": [
		"09f2",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-7ef9d28e",
		"chunk-a97b1978",
		"chunk-3005afd2",
		"chunk-65e4d47a",
		"chunk-52c38fea"
	],
	"./tsc/GenerateTranscript.vue": [
		"4ac4",
		"chunk-d8763076",
		"chunk-e33ebc78"
	],
	"./tsc/ManageAnnual.vue": [
		"8876",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-3e2c6fba"
	],
	"./tsc/ManageAnnualScore.vue": [
		"dbe4",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-b9cca562",
		"chunk-e45540a2",
		"chunk-74aefea6",
		"chunk-1f6cf470",
		"chunk-55e1a84e"
	],
	"./tsc/ManageGen.vue": [
		"3f7a",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-24e3875a"
	],
	"./tsc/ManageStudent.vue": [
		"d129",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-2d0b3a27",
		"chunk-d6f7cff8",
		"chunk-21b492ef",
		"chunk-6041540c",
		"chunk-45e48838",
		"chunk-1946f18a"
	],
	"./tsc/ManageTsc.vue": [
		"b697",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-367bb070",
		"chunk-8157dcc6",
		"chunk-74aefea6",
		"chunk-1f6cf470",
		"chunk-28d33692"
	],
	"./tsc/Transcript.vue": [
		"8ac4",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-08918e27",
		"chunk-2d217e88",
		"chunk-2d0be092"
	],
	"./tsc/TscManageLecturer.vue": [
		"9046",
		"chunk-d8763076",
		"chunk-07685898",
		"chunk-1280e9a0",
		"chunk-476392a9",
		"chunk-2d0b3a27",
		"chunk-6499a187",
		"chunk-4c3e8416",
		"chunk-bfc84be6",
		"chunk-db397138",
		"chunk-51dd180e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;